import { Page } from '@/core/architecture'

import { ConsoleUnpublishedPostsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePostsSchedule Page
 * Implemented as a practical sample.
 */
export const ConsoleUnpublishedPosts: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleUnpublishedPostsTemplate state={state} {...actions} />
}
